import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectQuotationState = (state: RootState) => state.quotationV2;

//This is the main loader
const isLoadingQuotation = createSelector(
  selectQuotationState,
  (state) => state.is_loading
);

const selectCategory = createSelector(
  selectQuotationState,
  (state) => state.category
);

const selectTemplate = createSelector(
  selectQuotationState,
  (state) => state.template
);

const selectProductOptions = createSelector(
  selectQuotationState,
  (state) => state.product
);

const selectQuotationData = createSelector(
  selectQuotationState,
  (state) => state.quotationData
);

const selectQuotationParams = createSelector(
  selectQuotationState,
  (state) => state.quotationProductParams
);

const selectTotalAmount = createSelector(
  selectQuotationState,
  (state) => state.totalAmount
);

const selectQuotationBranchId = createSelector(
  selectQuotationState,
  (state) => state.branch_id
);

export const selectors = {
  isLoadingQuotation,
  selectTemplate,
  selectCategory,
  selectProductOptions,
  selectQuotationData,
  selectQuotationParams,
  selectTotalAmount,
  selectQuotationBranchId
};
